import { render, staticRenderFns } from "./menage.vue?vue&type=template&id=d8a2ab06&scoped=true"
import script from "./menage.vue?vue&type=script&lang=js"
export * from "./menage.vue?vue&type=script&lang=js"
import style0 from "./menage.vue?vue&type=style&index=0&id=d8a2ab06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a2ab06",
  null
  
)

export default component.exports